// Vite's dynamic `import()` throws a hand-written message when a chunk 404s — wording
// differs per engine, but the family is small and stable enough to match on. This is the
// same failure `preloadErrorGuard` already reloads for: a deploy removed the chunk hashes
// this tab still references, not an application bug.
const CHUNK_IMPORT_ERROR_PATTERNS = [
	/failed to fetch dynamically imported module/i,
	/error loading dynamically imported module/i,
	/importing a module script failed/i,
];

export function isChunkImportError(error: unknown): boolean {
	const message = error instanceof Error ? error.message : String(error);
	return CHUNK_IMPORT_ERROR_PATTERNS.some((pattern) => pattern.test(message));
}
